// extracted by mini-css-extract-plugin
module.exports = {"firstFold":"firstFold_firstFold__l46_N","mainDiv":"firstFold_mainDiv__9PVC_","heading":"firstFold_heading___kYmz","subParagraph":"firstFold_subParagraph__D9Npm"};